
import { User } from '@/types';

// Mock Users
export const users: User[] = [

];
